<template>
  <div class="addproject-step2">
<!-- {{items}} -->
    На основе описания проекта и указанных задач рекомендуются следующие кандидаты:
<!-- {{curProject}} -->
    <div class="row mt-1">
      <div v-for="(h, ind) in headers" :key="ind" class="project-position-header" :class="h.cl" >
        {{ h.name }}
      </div>
    </div>
    <div v-for="(pos, ind) in curProject.positions" :key="ind" class="row">
      <div :class="headers[0].cl">
        <v-text-field :value="getRoleName(pos.role_id)" outlined dense hide-details readonly />
      </div>
      <div :class="headers[1].cl">
        <v-select :value="pos.candidates && pos.candidates[0] ? pos.candidates[0].id : 0"
          :items="pos.candidates" @change="setSelectedCandidateId({positionIndex: ind, candidateId: $event})"
          item-value="id" item-text="name" :menu-props="{ offsetY: true }" outlined dense hide-details
        />
      </div>
      <div :class="headers[2].cl">
        <v-textarea :value="getSelectedCandidate(ind).skills" class="position-textarea" outlined :rows="2" dense auto-grow hide-details />
      </div>
      <div :class="headers[3].cl">
        <v-text-field :value="getSelectedCandidate(ind).match+'%'" outlined dense hide-details readonly />
        <!-- <v-textarea :value="getSelectedCandidate(ind).matchedSkills" class="position-textarea" outlined dense auto-grow rows="3" /> -->
      </div>
      <div class="project-res-action">
        <v-btn class="" dense icon ><v-icon>mdi-reload</v-icon></v-btn>
        <v-btn class="" dense icon color="error"><v-icon>mdi-delete</v-icon></v-btn>
        <v-btn dense icon><img src="@/assets/images/profile/arrowGo.svg" /></v-btn>
      </div>
    </div>
    <div v-if="!hideControls" class="d-flex justify-end mt-8 mb-3 mr-7" >
      <v-btn @click="back()" color="primary" outlined class="mr-3 px-13">Назад</v-btn>
      <v-btn @click="next()" color="primary" class="px-13" :loading="loading.saveProject">Сохранить</v-btn>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'ProjectStep2',
  components: {
  },
  props:{
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showErrors: false,
      curInd: 0,
    };
  },
  computed: {
    ...mapGetters({
      items: 'ai/hrprojects/items',
      curProject: 'ai/hrprojects/curProject',
      roles: 'ai/hrprojects/roles',
      levels: 'ai/hrprojects/levels',
      loading: 'ai/hrprojects/loading',
      getRoleName: 'ai/hrprojects/getRoleName',
      getSelectedCandidate: 'ai/hrprojects/getSelectedCandidate',
    }),
    headers() {
      return [
        { name: 'Роль', cl: 'project-res-4-5' },
        { name: 'Кандидат', cl: 'project-res-4-5' },
        { name: 'Ключевые навыки', cl: 'project-res-4-5' },
        { name: 'Соответствие', cl: 'project-res-percent' }, 
      ]
    }
  },
  methods: {
    ...mapMutations({
      addPosition: 'ai/hrprojects/addPosition',
      removePosition: 'ai/hrprojects/removePosition',
      setSelectedCandidateId: 'ai/hrprojects/setSelectedCandidateId',
    }),
    ...mapActions({
      saveProject: 'ai/hrprojects/saveProject',
    }),
    back() {
      this.$emit('back')
    },
    async next() {
      await this.saveProject(this.curProject);
      this.$emit('next')
    },
  }
};
</script>

<style lang="scss" scoped>

.addproject-step4 {
  width: 1000px;
  max-width: 100%;
}


.project-res-4-5 {
  padding: 12px;
  flex: 0 0 calc((100% - 290px) / 3);
  width: calc((100% - 290px) / 3); /* 4 колонки + 5 отступов */
}

.project-res-percent {
  padding: 12px;
  width: 130px;
  flex: 0 0 130px;
}

.project-res-action {
  padding: 12px;
  width: 140px;
  flex: 0 0 140px;
}

</style>

